// import cookie from 'react-cookies'
// localStorage.removeItem('userdetails');
// localStorage.removeItem('userRole');
// // localStorage.removeItem('token');
// cookie.remove("token");
// window.location.href = '/';


import { useEffect } from 'react';
import cookie from 'react-cookies';
import postService from '../../Services/post-service';

const Logout = () => {
  useEffect(() => {
    const performLogout = async () => {
      try {
        await postService.Logout();
      } catch (error) {
        console.error("Backend logout failed, proceeding with local cleanup", error);
      } finally {
        localStorage.removeItem('userdetails');
        localStorage.removeItem('userRole');
        
        cookie.remove('token', { path: '/' });

        window.location.replace('/login');
      }
    };

    performLogout();
  }, []);

  return null; 
};

export default Logout;
